import React from 'react';
import { motion } from 'framer-motion';

const brands = [
  { name: 'Supercuts', logo: '/Logos/1.webp' },
  { name: 'Great Clips', logo: '/Logos/2.webp' },
  { name: 'Sport Clips', logo: '/Logos/3.webp' },
  { name: 'Hair Cuttery', logo: '/Logos/4.webp' },
  { name: 'Fantastic Sams', logo: '/Logos/5.webp' },
  { name: 'SmartStyle', logo: '/Logos/6.webp' },
  { name: 'Cost Cutters', logo: '/Logos/7.webp' },
  { name: 'Regis Salons', logo: '/Logos/8.webp' },
  { name: 'MasterCuts', logo: '/Logos/9.webp' },
  { name: 'Salon Centric', logo: '/Logos/10.webp' },
  { name: 'Salon Brand 11', logo: '/Logos/11.webp' },
  { name: 'Salon Brand 12', logo: '/Logos/12.webp' },
  { name: 'Salon Brand 13', logo: '/Logos/13.webp' },
  { name: 'Salon Brand 14', logo: '/Logos/14.webp' },
  { name: 'Salon Brand 15', logo: '/Logos/15.webp' },
  { name: 'Salon Brand 16', logo: '/Logos/16.webp' },
  { name: 'Salon Brand 17', logo: '/Logos/17.webp' },
  { name: 'Salon Brand 18', logo: '/Logos/18.webp' }
];

const BrandLogos: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-black mb-4">
            Trusted by Leading Salon Brands
          </h2>
          <p className="text-gray-600 text-lg">
            Join thousands of successful salon owners who trust Zylu
          </p>
        </motion.div>

        <div className="overflow-hidden">
          <motion.div
            animate={{ x: [-1000, 0] }}
            transition={{ 
              duration: 20,
              repeat: Infinity,
              ease: "linear"
            }}
            className="flex space-x-12 items-center"
          >
            {[...brands, ...brands].map((brand, index) => (
              <div
                key={index}
                className="flex-shrink-0 bg-white rounded-lg shadow-md border border-gray-200 flex items-center justify-center"
              >
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="h-20 w-auto object-contain"
                  onError={(e) => {
                    // Fallback to text if image fails to load
                    const target = e.target as HTMLImageElement;
                    target.style.display = 'none';
                    const fallback = target.nextElementSibling as HTMLElement;
                    if (fallback) fallback.style.display = 'block';
                  }}
                />
                <span 
                  className="text-xl font-semibold text-gray-700 whitespace-nowrap hidden"
                  style={{ display: 'none' }}
                >
                  {brand.name}
                </span>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default BrandLogos;